export const nav = {
  home: "Bem-vindo",
  howItWorks: "Como funciona",
  discover: "Descobrir",
  explore: "Explorar",
  exploreDesc: "Descubra membros e destinos",
  destinations: "Destinos",
  destinationsDesc: "Navegue pelos destinos disponíveis",
  membersMap: "Mapa de membros",
  membersMapDesc: "Encontre membros perto de você",
  pricing: "Preços",
  dashboard: "Painel de controlo",
  dashboardDesc: "Gerencie seus anúncios e trocas",
  mySpace: "Meu espaço",
  myCalendar: "Minha agenda",
  myCalendarDesc: "Gerencie seu calendário e trocas",
  incomingRequests: "Matching inteligente",
  incomingRequestsDesc: "Pedidos recebidos e sugestões IA",
  favorites: "Favoritos",
  favoritesDesc: "Os seus destinos favoritos",
  messaging: "Mensagens",
  messagingDesc: "Conversas e propostas",
  login: "Entrar",
  signup: "Registrar",
  corporate: "Empresa",
  announcement:
    "DONKEY TRAVEL — O clube europeu de troca de casas reservado para anfitriões do Airbnb com classificação 4,5 e superior",
};
